import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import {
  Menu, MenuItem,
  ListItem, ListItemText
} from '@mui/material';
import {
  Person
} from "@mui/icons-material";

import { User } from "@models";

import DandDAPI from "@dndUtilities/system_api";

interface Props {
  onLogout: () => void;
}

const api = DandDAPI.getInstance();

export default function UserMenu({
  onLogout,
}: Props) {
  const [navigateTo, setNavigateTo] = useState("");
  // const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<any>(null);
  const [processing, setProcessing] = useState(false);

  useEffect(() => {
    if (navigateTo !== "") {
      setAnchorEl(null);
      // setOpen(false);
      setNavigateTo("");
    }
  }, [navigateTo, setNavigateTo]);

  const adminMode = () => {
    setAnchorEl(null);
    if (api.user && api.user) {
      const admin = !api.user.admin;
      api.user.admin = admin;
      api.subscription_holder.reload();
    }
  }

  const reloadUser = async () => {
    setAnchorEl(null);
    if (api.user) {
      setProcessing(true);
      const res = await api.getPlayerObject({ data_type: "user", id: api.user._id });
      if (res instanceof User) {
        api.user = res;
        api.user = res;
      }
      setProcessing(false);
      api.subscription_holder.reload();
    }
  }

  const renderAdminOptions = () => {
    return [
      <MenuItem key="all_users"
        disabled={processing}
        onClick={() => {
          setNavigateTo(`/labs/user`);
        }}>
        <ListItemText primary="All Users" />
      </MenuItem>,
      <MenuItem key="toggle_admin"
        disabled={processing}
        onClick={adminMode}>
        <ListItemText primary="Toggle Admin Mode" />
      </MenuItem>
    ];
  }
  
  if (navigateTo !== "") {
    return <Navigate to={navigateTo} />;
  } else { 
    return (
      <span className="float-right">
        <ListItem 
          aria-controls="user-menu" aria-haspopup="true"
          style={{cursor: "pointer"}} 
          onClick={(event: any) => {
            setAnchorEl(event.currentTarget);
            // setOpen(true);
          }} 
          className="curvedButton float-right">
          <Person/>
          <ListItemText primary={` ${api.user?.username}`}/>
        </ListItem>
        <Menu
          id="customized-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={() => {
            setAnchorEl(null);
            // setOpen(false);
          }}
          elevation={0}
          anchorReference={undefined}
          // getContentAnchorEl={null}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}>
          <MenuItem
            disabled={processing}
            onClick={() => {
              setNavigateTo(`/labs/user/edit/${api.user?._id}`);
            }}>
            <ListItemText primary="My Account" />
          </MenuItem>
          { api.user && api.user.is_admin &&
            renderAdminOptions()
          }
          <MenuItem
            disabled={processing}
            onClick={reloadUser}>
            <ListItemText primary="Reload" />
          </MenuItem>
          <MenuItem
            disabled={processing}
            onClick={() => {
              localStorage.removeItem("loginUser");
              api.logout();
              onLogout();
            }}>
            <ListItemText primary="Logout" />
          </MenuItem>
        </Menu>
      </span>
    );
  }
}